import React from 'react';
import { useSound } from '../context/SoundContext';
import styles from './Header.module.css'; // Using Header styles for consistency, or create specific ones

const SoundToggle = () => {
  const { isSoundEnabled, toggleSound } = useSound();

  return (
    <button 
      onClick={toggleSound}
      style={{ 
          opacity: isSoundEnabled ? 1 : 0.5,
          cursor: 'pointer',
          background: 'none',
          border: 'none',
          color: 'inherit',
      }}
      aria-label={isSoundEnabled ? "Mute sounds" : "Unmute sounds"}
    >
      sound
    </button>
  );
};

export default SoundToggle;